import { types } from './actions';

const initialState = {
  contactId: null,
  isDeletingContact: false,
  isLoadingContact: false,
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case types.CONTACT_DETAILS_INIT:
      return {
        ...state,
        contactId: payload.contactId,
        isLoadingContact: true,
      };
    case types.DELETE_CONTACT_ERROR:
    case types.DELETE_CONTACT_SUCCESS:
      return {
        ...state,
        isDeletingContact: false,
      };
    case types.DELETE_CONTACT_REQUEST:
      return {
        ...state,
        isDeletingContact: true,
      };
    case types.FETCH_CONTACT_SUCCESS:
      return {
        ...state,
        isLoadingContact: false,
      };
    default:
      return state;
  }
};

const getScope = (state) => state.modules.contacts.contactDetails.app;

export const getContactId = (state) => getScope(state).contactId;

export const getIsDeletingContact = (state) =>
  getScope(state).isDeletingContact;

export const getIsLoadingContact = (state) => getScope(state).isLoadingContact;

export default reducer;
